import assetPath from '/opt/actions-runner/_work/crate/crate/packages/entity-pages/entity-pages-common/src/components/error-state/assets/error.svg';
export default [globalThis.crate.assetsBaseUrl, assetPath].join('/')